// kpiActions.js
export const SET_KPI_DATA = "SET_KPI_DATA";

export const setKPIData = (data) => ({
  type: SET_KPI_DATA,
  payload: data,
});